import React from 'react';
import { View, Text } from 'react-native';
import { TBatteryStatus } from '@shared/types';

export const BatteryIndicator: React.FC<TBatteryStatus> = ({ percentage, isCharging }) => {
  if (percentage === null) return null;

  const clamped = Math.min(100, Math.max(0, percentage));

  return (
    <View className="flex-row items-center gap-2" accessibilityRole="text" accessibilityLabel={`${clamped}%`}>
      <View className="flex-row items-center">
        <View className="h-[13px] w-[26px] justify-center rounded-[3px] border border-gray-500 p-px">
          <View className="h-full rounded-[1px] bg-gray-500" style={{ width: `${clamped}%` }} />
        </View>
        <View className="h-[5px] w-[2px] rounded-r-[1px] bg-gray-500" />
      </View>
      <Text className="text-[18px] font-semibold text-gray-500">
        {isCharging ? '⚡' : ''}
        {clamped}%
      </Text>
    </View>
  );
};
